import { gsap } from "gsap";

export default class MarqueeTitle {
    constructor() {
        this.newsWrap = document.querySelector(".js-gsap-marquee");
        this.newsList = document.querySelector(".js-gsap-marquee-list");
        this.newsListWidth = "";
        this.init();
    }

    init() {
        if (!this.newsWrap || !this.newsList) return;
        this.setupNewsItems();
    }

    setupNewsItems() {
        this.newsWrap.style.display = "flex";

        // 元のニュースリストをクローン（文字数の関係で2つクローン）
        for (let i = 0; i < 2; i++) {
            const clonedList = this.newsList.cloneNode(true);
            this.newsWrap.appendChild(clonedList);
        }

        // リスト全体の幅を計算して、ラッパーの幅を3倍に設定
        requestAnimationFrame(() => {
            this.newsListWidth = this.newsList.scrollWidth;
            this.newsWrap.style.width = `${this.newsListWidth * 3}px`;
            this.startAnimation();
        });
    }

    startAnimation() {
        const animationDuration = this.newsListWidth / 50;

        gsap.to(this.newsWrap, {
            x: -this.newsListWidth,
            duration: animationDuration,
            ease: "none",
            repeat: -1,
        });
    }
}
